import { LitElement, html } from "lit";
import { customElement, state } from "lit/decorators.js";

import { hashRouter } from "./utils/hash-router";

import "./pages/auto-home";
import "./pages/auto-settings";
import "./pages/auto-about";
import "./pages/auto-fof";

@customElement("auto-app")
class AutoApp extends LitElement {
  @state()
  private page: string = "home";
  @state() private router: object = hashRouter({
    "/": () => (this.page = "home"),
    settings: () => (this.page = "settings"),
    about: () => (this.page = "about"),
    "/404": () => (this.page = "notfound"),
  });

  disconnectedCallback() {
    this.router?.dispose();
    super.disconnectedCallback();
  }

  render() {
    return html`
      ${this.page === "home" ? html`<auto-home></auto-home>` : ""}
      ${this.page === "settings" ? html`<auto-settings></auto-settings>` : ""}
      ${this.page === "about" ? html`<auto-about></auto-about>` : ""}
      ${this.page === "notfound" ? html`<auto-fof></auto-fof>` : ""}
    `;
  }
}

if ("serviceWorker" in navigator) {
  navigator.serviceWorker.register(new URL("sw.js", import.meta.url), {
    type: "module",
  });
}

window.addEventListener("beforeinstallprompt", (event) => {
  console.log("install event");
});
